var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_note_svg__clip0_23474_100682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.994 1.543H5.973a4.43 4.43 0 00-4.43 4.43v12.02a4.43 4.43 0 004.43 4.43h12.02a4.43 4.43 0 004.43-4.43V5.974a4.43 4.43 0 00-4.43-4.43z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43 7.536c1.755 0 4.157-.09 5.882-.043 2.313.06 3.186 1.07 3.216 3.557.03 1.41 0 5.44 0 5.44h-2.504c0-3.528.012-4.111 0-5.223-.03-.98-.307-1.444-1.061-1.533-.797-.09-3.029-.013-3.029-.013v6.773H7.43V7.536z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.994 2.293H5.973a3.68 3.68 0 00-3.68 3.68v12.02a3.68 3.68 0 003.68 3.68h12.02a3.68 3.68 0 003.68-3.68V5.974a3.68 3.68 0 00-3.68-3.68zm-12.021-.75h12.02a4.43 4.43 0 014.43 4.43v12.02a4.43 4.43 0 01-4.43 4.43H5.974a4.43 4.43 0 01-4.43-4.43V5.974a4.43 4.43 0 014.43-4.43z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_note_svg__clip0_23474_100682"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.5 1.5)",
    d: "M0 0h21v21H0z"
  })))));
}

export default SvgIconNote;